import React, { useEffect, useState } from "react";
import { GrupoMateriais, formatarMateriaisComConsumo } from "../CadastroDosagem/CadastroDosagem";
import { useHistory } from "react-router-dom";
import {
  Box,
  Typography,
  CircularProgress,
  Card,
  CardContent,
  Alert,
  Button,
  Divider,
  TextField,
} from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

function MateriaisTracoLaudo({ laudo }) {
  if (laudo.tipo !== "Relatório de Dosagens" || !laudo.materiaisTraco) return null;
  const materiais = laudo.materiaisTraco;
  return (
    <Box sx={{ mt: 1, mb: 1, display: "grid", gap: 0.5, width: "100%", maxWidth: 560 }}>
      <Typography variant="caption" fontWeight={700}>Materiais</Typography>
      <GrupoMateriais rotulo="Cimento" itens={materiais.cimento} destaque />
      <GrupoMateriais rotulo="Adição" itens={materiais.adicoes} />
      <GrupoMateriais rotulo="Água" itens={materiais.agua} />
      <GrupoMateriais rotulo="Aditivos" itens={materiais.aditivos} />
      <GrupoMateriais rotulo="Agregados" itens={materiais.agregados} />
    </Box>
  );
}

import {
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
  orderBy,
} from "firebase/firestore";



import { auth, db } from "../Config/firebase";
import { getStorage, ref, getDownloadURL } from "firebase/storage";

const storage = getStorage();

import NavbarCliente from "../Components/NavbarCliente/NavbarCliente";
import { AMBIENTE_PRODUCAO, LOGO_SELO, NOME_PLATAFORMA } from "../Config/branding";
import TutorialCadastro from "../Components/TutorialCadastro/TutorialCadastro";
import { ETAPAS_TUTORIAL_LAUDOS } from "../Components/TutorialCadastro/etapasTutoriais";

const identificacaoDosagem = (laudo) => {
  const numero = laudo.numeroTraco || "-";
  const revisao = laudo.numeroRevisao;

  return revisao === "" || revisao === null || revisao === undefined
    ? `Dosagem nº ${numero}`
    : `Dosagem nº ${numero} - Revisão ${revisao}`;
};

const normalizarPesquisaLaudo = (valor) => String(valor ?? "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .toLowerCase()
  .trim();

const correspondePesquisaLaudo = (laudo, termo) => !termo || [
  laudo.numeroTraco,
  laudo.numeroRelatorio,
  laudo.codigoRelatorio,
  laudo.codigo,
  laudo.descricao,
  laudo.nomeArquivo,
  laudo.tipo === "Relatório de Dosagens" ? identificacaoDosagem(laudo) : "",
].some((valor) => normalizarPesquisaLaudo(valor).includes(termo));

const formatarDataEnvio = (valor) => {
  if (!valor) return "-";
  const data = valor?.toDate ? valor.toDate() : valor instanceof Date ? valor : new Date(valor);
  return Number.isNaN(data.getTime()) ? "-" : data.toLocaleDateString("pt-BR");
};

const dataEnvioMillis = (laudo) => {
  const valor = laudo?.criadoEm || laudo?.atualizadoEm;
  const data = valor?.toDate ? valor.toDate() : valor instanceof Date ? valor : new Date(valor || 0);
  return Number.isNaN(data.getTime()) ? 0 : data.getTime();
};

const chaveRelatorioLaudo = (laudo) => {
  const codigoRelatorio = String(laudo?.codigoRelatorio || laudo?.codigo || "").trim();
  if (codigoRelatorio) return `codigo:${codigoRelatorio.toUpperCase()}`;

  const numeroRelatorio = String(laudo?.numeroRelatorio ?? "").trim();
  if (numeroRelatorio) return `numero:${numeroRelatorio}`;

  const descricao = String(laudo?.descricao || "").trim();
  const codigoNaDescricao = descricao.match(/\b(?:RE-[A-Z]+|R[A-Z]*)-?\d+(?:\.[A-Z0-9]+)?\b/i)?.[0];
  if (codigoNaDescricao) return `descricao-codigo:${codigoNaDescricao.toUpperCase()}`;

  const nomeArquivo = String(laudo?.nomeArquivo || "").trim();
  return `texto:${(descricao || nomeArquivo || laudo?.id || "SEM_IDENTIFICACAO").toUpperCase()}`;
};

const ehRelatorioRupturas = (tipo) =>
  String(tipo || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase() === "relatorio de rupturas";

const ehRelatorioPegaCimento = (tipo) =>
  String(tipo || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .includes("pega do cimento");

const chaveRelatorioPegaCimento = (laudo) => {
  const texto = [
    laudo?.codigoRelatorio,
    laudo?.codigo,
    laudo?.descricao,
    laudo?.nomeArquivo,
  ]
    .filter(Boolean)
    .join(" ");
  const codigo = texto.match(
    /\b(?:CE[\s._-]*)?RE[\s._-]*IP[\s._-]*(\d{3,})[\s._-]*(\d{4})\b/i
  );

  return codigo
    ? `CE-RE-IP-${codigo[1]}-${codigo[2]}`
    : chaveRelatorioLaudo(laudo);
};

export default function Laudos({ open, isMobile }) {
  const history = useHistory();
  const usuarioCliente = String(localStorage.getItem("tipoUsuario") || "").toLowerCase() === "cliente";
  const [loading, setLoading] = useState(true);
  const [laudos, setLaudos] = useState([]);
  const [erro, setErro] = useState("");
  const [obrasNomes, setObrasNomes] = useState([]);
  const [mostrarHistorico, setMostrarHistorico] = useState({});
  const [mostrarTodos, setMostrarTodos] = useState({});
  const [obrasAbertas, setObrasAbertas] = useState({});
  const [tiposAbertos, setTiposAbertos] = useState({});
  const [pesquisasLaudos, setPesquisasLaudos] = useState({});
  const [filtroObra, setFiltroObra] = useState("");
  const [openTutorial, setOpenTutorial] = useState(false);



/* =========================
   DOWNLOAD DO LAUDO
========================= */
const baixarLaudo = async (storagePath, nomeArquivo) => {
  try {
    const url = await getDownloadURL(ref(storage, storagePath));

    const a = document.createElement("a");
    a.href = url;
    a.download = nomeArquivo;
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (error) {
    console.error("Erro ao baixar laudo:", error);
    alert("Erro ao baixar o arquivo.");
  }
};


  /* =========================
     CARREGAR LAUDOS
  ========================= */
  useEffect(() => {
    async function carregarLaudos() {
      try {
        const user = auth.currentUser;
        if (!user) {
          setErro("Usuário não autenticado");
          return;
        }

        const userSnap = await getDoc(doc(db, "users", user.uid));
        if (!userSnap.exists()) {
          setErro("Usuário não encontrado");
          return;
        }

        const dadosUsuario = userSnap.data();
        const { obras, tenantId } = dadosUsuario;
        
        if (!obras || obras.length === 0) {
          setErro("Nenhuma obra vinculada ao usuário");
          return;
        }

        if (!tenantId) {
          setErro("Usuário sem tenantId");
          return;
        }

        const nomes = {};
const listaNomes = [];

for (const obraId of obras) {
  const obraSnap = await getDoc(doc(db, "obras", obraId));
  if (obraSnap.exists()) {
    const nome = obraSnap.data().nome;
    nomes[obraId] = nome;
    listaNomes.push(nome);
  }
}

setObrasNomes(nomes);



        let lista = [];

const consultas = obras.map((obraId) => {
  return getDocs(
    query(
      collection(db, "laudos"),
      where("tenantId", "==", tenantId),
      where("obraId", "==", obraId)
    )
  );
});

const resultados = await Promise.all(consultas);

lista = resultados.flatMap((snap) =>
  snap.docs.map((documento) => ({
    id: documento.id,
    ...documento.data(),
  }))
);

lista = lista
  .filter((laudo) => !laudo.cancelado)
  .sort((a, b) => {
    const dataA = a.criadoEm?.toDate ? a.criadoEm.toDate() : new Date(0);
    const dataB = b.criadoEm?.toDate ? b.criadoEm.toDate() : new Date(0);
    return dataB - dataA;
  });

// Laudos antigos usam o código para localizar os materiais no cadastro da obra.
const obrasSemMateriais = [...new Set(lista
  .filter((laudo) => laudo.tipo === "Relatório de Dosagens" && !laudo.materiaisTraco)
  .map((laudo) => laudo.obraId))];
const consultasDosagens = await Promise.allSettled(obrasSemMateriais.map((obraId) =>
  getDocs(query(collection(db, "tblDosagensConcreto"),
    where("tenantId", "==", tenantId), where("obraId", "==", obraId)))
));
const dosagens = consultasDosagens.flatMap((resultado) => {
  if (resultado.status === "rejected") {
    console.error("Não foi possível carregar os materiais das dosagens:", resultado.reason);
    return [];
  }
  return resultado.value.docs.map((documento) => ({ ...documento.data(), id: documento.id }));
});
const normalizarNumero = (valor) => String(valor || "").replace(/\D/g, "").replace(/^0+(?=\d)/, "");
const codigoDosagemLaudo = (valor) => {
  const texto = String(valor ?? "").trim();
  const codigo = texto.match(/(?:^|[^a-z0-9])T\s*(\d+)/i)?.[1];
  return codigo ? normalizarNumero(codigo) : /^\d+$/.test(texto) ? normalizarNumero(texto) : "";
};
const normalizarRevisao = (valor, descricao) => normalizarNumero(valor ?? String(descricao || "").match(/REV\.?\s*(\d+)/i)?.[1] ?? "0") || "0";
lista = lista.map((laudo) => {
  if (laudo.tipo !== "Relatório de Dosagens" || laudo.materiaisTraco) return laudo;
  const numero = codigoDosagemLaudo(laudo.numeroTraco) || codigoDosagemLaudo(laudo.descricao) || codigoDosagemLaudo(laudo.nomeArquivo);
  const revisao = normalizarRevisao(laudo.numeroRevisao, laudo.descricao);
  const candidatas = dosagens.filter((dosagem) =>
    dosagem.tenantId === tenantId && dosagem.obraId === laudo.obraId &&
    (laudo.dosagemId ? dosagem.id === laudo.dosagemId :
      Boolean(numero) && (codigoDosagemLaudo(dosagem.codigo) || codigoDosagemLaudo(dosagem.traco)) === numero)
  );
  const mesmaRevisao = candidatas.filter((dosagem) => normalizarRevisao(dosagem.numeroRevisao, dosagem.traco) === revisao);
  const mesmoNome = candidatas.filter((dosagem) =>
    String(dosagem.traco || "").trim().toUpperCase() === String(laudo.descricao || "").trim().toUpperCase()
  );
  const correspondencias = mesmoNome.length ? mesmoNome : mesmaRevisao.length ? mesmaRevisao : candidatas;
  if (correspondencias.length !== 1) return laudo;
  const dosagem = correspondencias[0];
  return { ...laudo, materiaisTraco: {
    cimento: formatarMateriaisComConsumo(dosagem, "cimento"),
    adicoes: formatarMateriaisComConsumo(dosagem, "adicoesResumo"),
    agua: formatarMateriaisComConsumo(dosagem, "agua"),
    aditivos: formatarMateriaisComConsumo(dosagem, "aditivosResumo"),
    agregados: formatarMateriaisComConsumo(dosagem, "materiaisResumo"),
  } };
});
setLaudos(lista);




      } catch (error) {
        console.error(error);
        setErro("Erro ao carregar laudos");
      } finally {
        setLoading(false);
      }
    }

    carregarLaudos();
  }, []);

  /* =========================
     DADOS DERIVADOS
  ========================= */
  const laudosPorObra = {};
  const termoPesquisaGeral = normalizarPesquisaLaudo(filtroObra);

laudos.forEach(l => {
  if (termoPesquisaGeral &&
      !normalizarPesquisaLaudo(obrasNomes[l.obraId]).includes(termoPesquisaGeral) &&
      !correspondePesquisaLaudo(l, termoPesquisaGeral)) return;
  if (!laudosPorObra[l.obraId]) {
    laudosPorObra[l.obraId] = {};
  }

  if (!laudosPorObra[l.obraId][l.tipo]) {
    laudosPorObra[l.obraId][l.tipo] = {};
  }

  const isDosagem = l.tipo === "Relatório de Dosagens";

  const chaveTraco = isDosagem
    ? (l.numeroTraco || "SEM_TRAÇO")
    : usuarioCliente && ehRelatorioPegaCimento(l.tipo)
    ? chaveRelatorioPegaCimento(l)
    : usuarioCliente && ehRelatorioRupturas(l.tipo)
    ? "RELATORIO_UNICO_RUPTURAS"
    : chaveRelatorioLaudo(l);

  if (!laudosPorObra[l.obraId][l.tipo][chaveTraco]) {
    laudosPorObra[l.obraId][l.tipo][chaveTraco] = [];
  }

  laudosPorObra[l.obraId][l.tipo][chaveTraco].push(l);
});


const obrasOrdenadas = Object.keys(laudosPorObra)
  .sort((a, b) =>
    (obrasNomes[a] || "").localeCompare(obrasNomes[b] || "", "pt-BR", {
      sensitivity: "base",
    })
  );



  /* =========================
     RENDER
  ========================= */
  return (
  
      <>
  <NavbarCliente />

  {/* FUNDO DA PÁGINA */}
  <Box
    sx={{
      minHeight: "100vh",
      backgroundColor: "#dfebf8",
      pt: 5, // mantém distância do navbar
      pb: 6,
    }}
  >
    {/* CONTAINER CENTRAL (CONTROLA MARGENS LATERAIS) */}
    <Box
      sx={{
        maxWidth: 1200,
        mx: "auto",
        px: { xs: 2, md: 4 }, // 👈 margens laterais responsivas
      }}
    >
      {loading && <CircularProgress />}

      {erro && <Alert severity="error">{erro}</Alert>}

      {!loading && !erro && laudos.length === 0 && (
        <Alert severity="info">
          Nenhum laudo está disponível no momento para esta obra.
        </Alert>
      )}

     {/* CABEÇALHO – OBRAS VINCULADAS */}
{Object.keys(obrasNomes).length > 0 && (

  <Card
    sx={{
      mb: 4,
      background: "linear-gradient(135deg, #1e88e5 0%, #42a5f5 100%)",
      color: "#ffffff",
      borderRadius: 3,
      position: "relative",
      overflow: "visible",
    }}
  >
    <CardContent
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        pr: 10,
      }}
    >
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
          <Typography variant="h4" fontWeight={700}>
            Laudos Técnicos da Obra
          </Typography>
          <Button
            variant="outlined"
            color="inherit"
            startIcon={<HelpOutlineIcon />}
            onClick={() => setOpenTutorial(true)}
            sx={{ borderColor: "rgba(255,255,255,.8)", color: "#fff" }}
          >
            Ver tutorial
          </Button>
        </Box>

       

        <Typography
          variant="body1"
          sx={{
            mt: 1.2,
            fontSize: "1.05rem",
            fontWeight: 500,
            color: "#ffffff",
          }}
        >
          Você está visualizando os laudos mais recentes das obras vinculadas.
        </Typography>
      </Box>
    </CardContent>

    {/* LOGO ISO */}
    {AMBIENTE_PRODUCAO && (
      <Box
        sx={{
          position: "absolute",
          top: "55%",
          right: -115,
          transform: "translateY(-50%)",
          opacity: 0.95,
        }}
      >
        <img
          src={LOGO_SELO}
          alt={NOME_PLATAFORMA}
          style={{ height: 160 }}
        />
      </Box>
    )}
  </Card>
)}
<Box sx={{ mb: 3 }}>
  <TextField
    label="Pesquisar obra ou arquivo"
    placeholder="Digite a obra, nome do arquivo, descrição, código ou número"
    fullWidth
    value={filtroObra}
    onChange={(e) => {
      setFiltroObra(e.target.value);
      setPesquisasLaudos({});
    }}
  />
</Box>



      {/* LAUDO ATUAL */}
      {!loading && !erro && termoPesquisaGeral && obrasOrdenadas.length === 0 && (
        <Alert severity="info">Nenhuma obra ou arquivo encontrado para esta pesquisa.</Alert>
      )}
      {obrasOrdenadas
        
.map((obraId) => {

  const tipos = laudosPorObra[obraId];
  const obraAberta = Boolean(termoPesquisaGeral) || Boolean(obrasAbertas[obraId]);

  return (
    <Card
      key={obraId}
      sx={{
        mb: 3,
        borderLeft: "6px solid #1e88e5",
        boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
        borderRadius: 2,
      }}
    >
      <CardContent sx={{ pb: obraAberta ? 2 : "16px !important" }}>
        <Box
          component="div"
          role="button"
          tabIndex={0}
          onClick={() =>
            setObrasAbertas((prev) => ({
              ...prev,
              [obraId]: !prev[obraId],
            }))
          }
          onKeyDown={(event) => {
            if (event.key !== "Enter" && event.key !== " ") return;
            event.preventDefault();
            setObrasAbertas((prev) => ({
              ...prev,
              [obraId]: !prev[obraId],
            }));
          }}
          sx={{
            width: "100%",
            mb: obraAberta ? 2 : 0,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
            border: 0,
            p: 0,
            background: "transparent",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, minWidth: 0 }}>
            {obraAberta ? (
              <ExpandLessIcon sx={{ color: "#1e88e5", flexShrink: 0 }} />
            ) : (
              <ExpandMoreIcon sx={{ color: "#1e88e5", flexShrink: 0 }} />
            )}
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{ color: "#1e88e5" }}
            >
              {obrasNomes[obraId]}
            </Typography>
          </Box>

          <Button
            variant="outlined"
            size="small"
            onClick={(event) => {
              event.stopPropagation();
              history.push({
                pathname: "/app/agendamoldagem",
                state: {
                  obraId,
                  obraNome: obrasNomes[obraId],
                  somenteLeitura: true,
                  voltarParaLaudos: true,
                },
              });
            }}
          >
           Resultados de ruptura diária
          </Button>
        </Box>

        {obraAberta && Object.keys(tipos)
  .sort((a, b) => a.localeCompare(b, "pt-BR", { sensitivity: "base" }))
  .map((tipo) => {


       const gruposTracos = tipos[tipo] || {};
       const numerosTracos = Object.keys(gruposTracos);
       if (tipo === "Relatório de Dosagens") {
         numerosTracos.sort((a, b) => (Number(b) || 0) - (Number(a) || 0));
       }
       const chaveTipo = JSON.stringify([obraId, tipo]);
       const tipoAberto = Boolean(termoPesquisaGeral) || Boolean(tiposAbertos[chaveTipo]);
       const termoPesquisa = normalizarPesquisaLaudo(pesquisasLaudos[chaveTipo]);
       const gruposFiltrados = numerosTracos.filter((numeroTraco) =>
         gruposTracos[numeroTraco].some((laudo) => correspondePesquisaLaudo(laudo, termoPesquisa))
       );

return (
  <Box key={tipo} sx={{ mb: 2 }}>
    <Button
      fullWidth
      aria-expanded={tipoAberto}
      onClick={() => setTiposAbertos((anteriores) => ({
        ...anteriores,
        [chaveTipo]: !anteriores[chaveTipo],
      }))}
      endIcon={tipoAberto ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      sx={{
        mb: tipoAberto ? 2 : 0,
        px: 2,
        py: 1.2,
        borderLeft: "5px solid #1565c0",
        borderRadius: 1,
        backgroundColor: "#eaf3ff",
        color: "#0d47a1",
        fontWeight: 800,
        textTransform: "none",
        textAlign: "left",
        justifyContent: "space-between",
      }}
    >
      {tipo}
    </Button>
    {tipoAberto && (
      <TextField
        fullWidth
        size="small"
        label={`Pesquisar arquivo em ${tipo}`}
        placeholder="Digite o número, código, descrição ou nome do arquivo"
        value={pesquisasLaudos[chaveTipo] || ""}
        onChange={(event) => setPesquisasLaudos((anteriores) => ({
          ...anteriores,
          [chaveTipo]: event.target.value,
        }))}
        sx={{ mb: 2 }}
      />
    )}
    {tipoAberto && gruposFiltrados.length === 0 && (
      <Typography color="text.secondary" sx={{ mb: 2 }}>
        Nenhum arquivo encontrado para esta pesquisa.
      </Typography>
    )}
    {tipoAberto && gruposFiltrados.map((numeroTraco, indiceGrupo) => {

  const lista = (gruposTracos[numeroTraco] || [])
    .filter((laudo) => correspondePesquisaLaudo(laudo, termoPesquisa))
    .sort((a, b) => {
  if (usuarioCliente && tipo === "Relatório de Dosagens") {
    const tracoA = Number(a.numeroTraco || 0);
    const tracoB = Number(b.numeroTraco || 0);

    if (tracoA !== tracoB) return tracoB - tracoA;

    const revisao = Number(b.numeroRevisao || 0) - Number(a.numeroRevisao || 0);
    return revisao || dataEnvioMillis(b) - dataEnvioMillis(a);
  }

  if (usuarioCliente) {
    const data = dataEnvioMillis(b) - dataEnvioMillis(a);
    if (data) return data;

    const numero = Number(b.numeroRelatorio || 0) - Number(a.numeroRelatorio || 0);
    if (numero) return numero;

    return Number(b.numeroRevisao || 0) - Number(a.numeroRevisao || 0);
  }

  const dataA = a.criadoEm?.toDate ? a.criadoEm.toDate() : new Date(0);
  const dataB = b.criadoEm?.toDate ? b.criadoEm.toDate() : new Date(0);
  if (dataA.getTime() !== dataB.getTime()) return dataB - dataA;

  return Number(b.numeroRevisao || 0) - Number(a.numeroRevisao || 0);
});

const listaExibicao = !termoPesquisaGeral && usuarioCliente && tipo === "Relatório de Dosagens"
  ? lista.filter((item, index, itens) =>
      itens.findIndex((outro) => String(outro.numeroRevisao ?? "") === String(item.numeroRevisao ?? "")) === index
    )
  : lista;

if (listaExibicao.length === 0) return null;

const atual = listaExibicao[0];
const historico = listaExibicao.slice(1);
const historicoLimitado = listaExibicao.slice(1, 4);


          return (
              <Box key={`${tipo}-${numeroTraco}`} sx={{ mb: 4 }}>

               {indiceGrupo > 0 && <Divider
                    sx={{
                      mb: 2,
                      borderBottomWidth: 3,
                      borderColor: "#c4c4c4",
                      opacity: 1
                    }}
                  />}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 2,
                }}
              >
                <Box>
                  <Typography fontWeight={600}>
                    {atual.tipo === "Relatório de Dosagens"
                      ? identificacaoDosagem(atual)
                      : atual.descricao}
                  </Typography>

                  {atual.tipo === "Relatório de Dosagens" && atual.descricao && (
                    <Typography variant="body2">
                      {atual.descricao}
                    </Typography>
                  )}

                  <Typography variant="body2" color="text.secondary">
                    {termoPesquisaGeral || termoPesquisa ? "Resultado da pesquisa" : "Última versão disponível"}
                  </Typography>
                  {termoPesquisaGeral && atual.nomeArquivo && (
                    <Typography variant="body2" sx={{ overflowWrap: "anywhere" }}>{atual.nomeArquivo}</Typography>
                  )}
                  <MateriaisTracoLaudo laudo={atual} />
                  <Typography variant="body2" color="text.secondary">
                    Enviado em: {formatarDataEnvio(atual.criadoEm || atual.atualizadoEm)}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", gap: 1 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() =>
                      baixarLaudo(atual.storagePath, atual.nomeArquivo)
                    }
                  >
                    Baixar PDF
                  </Button>

                  {!termoPesquisaGeral && !usuarioCliente && historico.length > 0 && (
                    <Button
                      variant="text"
                      size="small"
                      onClick={() =>
                        setMostrarHistorico(prev => ({
                          ...prev,
                          [`${obraId}-${tipo}-${numeroTraco}`]: !prev[`${obraId}-${tipo}-${numeroTraco}`],
                        }))
                      }
                    >
                      {mostrarHistorico[`${obraId}-${tipo}-${numeroTraco}`]
                        ? "Ocultar histórico"
                        : "Histórico"}
                    </Button>
                  )}
                </Box>
              </Box>

              {usuarioCliente && historico.length > 0 && (
                <>
                  {!termoPesquisaGeral && <Button
                    size="small"
                    variant="text"
                    startIcon={mostrarHistorico[`${obraId}-${tipo}-${numeroTraco}`] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    sx={{ mt: 1 }}
                    onClick={() =>
                      setMostrarHistorico((prev) => ({
                        ...prev,
                        [`${obraId}-${tipo}-${numeroTraco}`]: !prev[`${obraId}-${tipo}-${numeroTraco}`],
                      }))
                    }
                  >
                    {mostrarHistorico[`${obraId}-${tipo}-${numeroTraco}`]
                      ? "Mostrar menos"
                      : `Mostrar mais (${historico.length})`}
                  </Button>}

                  {(termoPesquisaGeral || mostrarHistorico[`${obraId}-${tipo}-${numeroTraco}`]) && historico.map((item) => (
                    <Box
                      key={item.id}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 2,
                        mt: 1.5,
                        pt: 1.5,
                        borderTop: "1px solid #e0e0e0",
                      }}
                    >
                      <Box>
                        <Typography variant="body2">
                          {item.tipo === "Relatório de Dosagens"
                            ? identificacaoDosagem(item)
                            : item.descricao}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          Enviado em: {formatarDataEnvio(item.criadoEm || item.atualizadoEm)}
                        </Typography>
                        {termoPesquisaGeral && item.nomeArquivo && (
                          <Typography variant="body2" sx={{ overflowWrap: "anywhere" }}>{item.nomeArquivo}</Typography>
                        )}
                        <MateriaisTracoLaudo laudo={item} />
                      </Box>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => baixarLaudo(item.storagePath, item.nomeArquivo)}
                      >
                        Baixar PDF
                      </Button>
                    </Box>
                  ))}
                </>
              )}

              {!usuarioCliente && (termoPesquisaGeral || mostrarHistorico[`${obraId}-${tipo}-${numeroTraco}`]) && historico.length > 0 && (
                <Box sx={{ mt: 2 }}>
                  <Divider sx={{ mb: 2 }} />

                  {(termoPesquisaGeral || mostrarTodos[`${obraId}-${tipo}-${numeroTraco}`] ? historico : historicoLimitado).map((item) => (
                    <Box
                      key={item.id}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 1,
                      }}
                    >
                      <Box>
                        <Typography variant="body2">
                          {item.tipo === "Relatório de Dosagens"
                            ? identificacaoDosagem(item)
                            : item.descricao}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          Responsável: {item.criadoPorEmail || "Usuário não identificado"}
                        </Typography>
                        {termoPesquisaGeral && item.nomeArquivo && (
                          <Typography variant="body2" sx={{ overflowWrap: "anywhere" }}>{item.nomeArquivo}</Typography>
                        )}
                        <MateriaisTracoLaudo laudo={item} />
                      </Box>

                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() =>
                          baixarLaudo(item.storagePath, item.nomeArquivo)
                        }
                      >
                        Baixar
                      </Button>
                    </Box>
                  ))}
                  {!termoPesquisaGeral && historico.length > 3 && (
                    <Button
                      size="small"
                      variant="text"
                      onClick={() =>
                        setMostrarTodos(prev => ({
                          ...prev,
                          [`${obraId}-${tipo}-${numeroTraco}`]: !prev[`${obraId}-${tipo}-${numeroTraco}`],
                        }))
                      }
                    >
                      {mostrarTodos[`${obraId}-${tipo}-${numeroTraco}`] ? "Mostrar menos" : "Mostrar todos"}
                    </Button>
                  )}

                </Box>
              )}
            </Box>
                    );
        })}
  </Box>
);
      })}
      </CardContent>
    </Card>
           );
        })}
    

          

      {/* POLÍTICA DA QUALIDADE */}
      <Card sx={{ borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Política da Qualidade
          </Typography>

<Typography
  variant="body1"
  fontStyle="italic"
  color="text.secondary"
>
  “Executar serviços de qualidade fundamentados em bases sólidas e concretas, visando a melhoria contínua e completa satisfação dos clientes”
</Typography>


          <Divider sx={{ my: 2 }} />

          <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" },
                  gap: 2,
                }}
              >

            <Box>
              <Typography fontWeight={600}>Missão</Typography>
              <Typography variant="body2">
                Oferecer com excelência serviços de controle tecnológico.
              </Typography>
            </Box>  

            <Box>
              <Typography fontWeight={600}>Visão</Typography>
              <Typography variant="body2">
                Ser referência no controle tecnológico.
              </Typography>              
            </Box>
                  <Box>
                    <Typography fontWeight={600}>Valores</Typography>

                    <Typography variant="body2">✓ Excelência em qualidade e atendimento;</Typography>
                    <Typography variant="body2">✓ Pontualidade: Atender sempre no prazo combinado;</Typography>
                    <Typography variant="body2">✓ Crescimento contínuo com inovação constante;</Typography>
                    <Typography variant="body2">✓ Sustentabilidade;</Typography>
                    <Typography variant="body2">✓ Ética.</Typography>
                  </Box>


          </Box>
        </CardContent>
      </Card>
      <TutorialCadastro
        open={openTutorial}
        onClose={() => setOpenTutorial(false)}
        titulo="Tutorial — Laudos"
        etapas={ETAPAS_TUTORIAL_LAUDOS}
      />
    </Box>
  </Box>
</>

  );
}
